<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="card">
            <FlashMessage :position="'right top'"></FlashMessage>

            <div class="card-header">
                <h4 class="title">Edit Category</h4>
            </div>
            <div class="card-body">
                <form @submit.prevent="update" enctype="multipart/form-data">
                    <div class="row">
                        <div class="col-md-4">
                            <label>Category<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.categorydata.categoryname.$model" type="text" label="Category" placeholder="Enter category" />
                            <div class="error" v-if="submitted && !$v.categorydata.categoryname.required">Please enter category</div>

                        </div>

                        <div class="col-md-4">
                            <label>Image<em style="color:red">*</em></label>
                            <input class="form-control" type="file" label="Image" name="categoryimage" id="categoryimage" accept="image/x-png,image/gif,image/jpeg" @change="onFileSelected" />
                            <img :src="api+'/storage/image/'+categorydata.categoryimage" height="100px">
                            <!-- <div class="error" v-if="submitted && !$v.categorydata.categoryimage.required">Please select image</div> -->

                        </div>

                        <div class="col-md-4">
                            <label>Status<em style="color:red">*</em></label>
                            <select class="form-control" v-model.trim="$v.categorydata.categorystatus.$model">
                                <option disabled>Select status</option>
                                <option value="1">Active</option>
                                <option value="0">InActive</option>
                            </select>
                            <div class="error" v-if="submitted && !$v.categorydata.categorystatus.required">Please select status</div>

                        </div>

                    </div>

                    <div class="text">
                        <button type="submit" class="btn btn-secondary dashboard">Update</button>&nbsp;
                        <router-link to="/admin/dashboard/category"><button type="button" class="btn btn-secondary dashboard">Cancel</button></router-link>

                    </div>

                </form>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import {
    required,
    minLength,
    maxLength,
    between,
} from "vuelidate/lib/validators";
export default {
    name: 'editCategory',
    components: {
        TopNavbar,
        ContentFooter,
    },

    data() {
        return {
            submitted: false,
            api: process.env.VUE_APP_API_BASE_URL,
            categorydata: {
                categoryname: '',
                categoryimage: [],
                categorystatus: '',
            }
        }
    },

    validations: {
        categorydata: {
            categoryname: {
                required,
            },
            // categoryimage: {
            //     required,
            // },
            categorystatus: {
                required,
            },
        }
    },

    methods: {

        onFileSelected(event) {
            this.categorydata.categoryimage = event.target.files[0];
        },

        update() {

            let formData = new FormData();
            formData.append('categoryimage', this.categorydata.categoryimage);
            formData.append('categoryname', this.categorydata.categoryname);
            formData.append('categorystatus', this.categorydata.categorystatus);

            this.submitted = true;
            this.$v.$touch()
            if (this.$v.$invalid) {
                return;
            } else {
                this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/category/update/` + this.$route.params.id, formData)
                    .then(({
                        data
                    }) => {
                        this.$router.push('/admin/dashboard/category');
                        this.flashMessage.success({
                            message: 'Category Updated Successfully',
                        });
                    })
                // .catch((error) => {
                //     console.log(error);
                // });
            }
        }
    },

    async mounted() {
        const categorydata = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/category/edit/` + this.$route.params.id);
        this.categorydata = categorydata.data.data;

    },

};
</script>

<style lang="scss">
</style>
